import { atom } from 'jotai';
import { Role } from 'types/user';

export const permissionsEditAtom = atom<Role['permissions']>([]);
export const modulesEditAtom = atom<Role['modules']>([]);
